/**
 * Extrae SOPInstanceUID de query WADO (`objectUID` / `o`).
 * @param {string|null|undefined} url
 * @returns {string|null}
 */
export function sopFromWadoUrl(url) {
  if (!url || typeof url !== 'string') return null
  try {
    const u = new URL(String(url).replace(/^wadouri:/i, ''), 'https://local.invalid')
    const keys = ['objectUID', 'ObjectUID', 'o', 'sopInstanceUID', 'SOPInstanceUID']
    for (let i = 0; i < keys.length; i++) {
      const v = u.searchParams.get(keys[i])
      if (v != null && String(v).trim()) return String(v).trim()
    }
  } catch (e) {
    const m = /[?&](?:objectUID|ObjectUID|o|sopInstanceUID)=([^&]+)/i.exec(
      String(url)
    )
    if (m && m[1]) {
      try {
        return decodeURIComponent(m[1]).trim() || null
      } catch (e2) {
        return String(m[1]).trim() || null
      }
    }
  }
  return null
}

/**
 * SOP del manifest o null (incluye `o=` en URLs WADO legacy).
 * @param {object} inst
 * @returns {string|null}
 */
export function sopFromManifestInstance(inst) {
  if (!inst || typeof inst !== 'object') return null
  const candidates = [
    inst.sopInstanceUID,
    inst.SOPInstanceUID,
    inst.objectUID,
    inst.sop,
    inst.instanceUID,
  ]
  for (const c of candidates) {
    if (c != null && String(c).trim()) return String(c).trim()
  }
  const urlCand =
    inst.url ||
    inst.dicomUrl ||
    inst.wadoUrl ||
    (inst.imageId && String(inst.imageId).replace(/^wadouri:/i, '')) ||
    null
  return sopFromWadoUrl(urlCand)
}
